import { instance } from "../config/serverConfig";

export const codeOfConduct = "https://answers.microsoft.com/en-us/page/codeofconduct";
export const dataWeCollect = "https://go.microsoft.com/fwlink/?LinkId=2101474";
export const msftSupport = "https://support.microsoft.com/en-US";
export const msftGlobalPrivacyStatement = "https://privacy.microsoft.com/en-US/data-privacy-notice";

const privacyUrlExternal = "https://aka.ms/DevComprivacystatement";
const privacyUrlInternal = "https://aka.ms/DevCominternalprivacystatement";

export function getPrivacyStatementUrl(): string {
    return instance?.isInternal ? privacyUrlInternal : privacyUrlExternal;
}

export function getDevComUrl(): string {
    return window.location.origin;
}

export const updateVisualStudio = "https://docs.microsoft.com/en-us/visualstudio/install/update-visual-studio";
export const visualStudioLifecycle = "https://aka.ms/vs/lifecycle/policy";

// Set the downloadUrl from cookie so that we can have different values for Production & PPE
// https://aka.ms/dc --> Production
// https://aka.ms/dcppe --> PPE
export const userImagesUrl = `${instance?.downloadUrl}/image`;
export const userFilesUrl = `${instance?.downloadUrl}/file`;
export const userInfoUrl = `${instance?.downloadUrl}/u`;

// @TODO: Update with correct link
export const feedbackProcess = "@TODO";

export enum AppPaths {
    home = "/home",
    moderation = "/moderation",
    report = "/report",
    suggest = "/suggest",
    myfeedback = "/myfeedback",
    myactivity = "/myactivity",
    profile = "/profile",
    /** ticket */
    t = "/t",
    search = "/search",
    knownSlugVisualStudio = "/VisualStudio",
    fixes = "/fixes", // recent fixes page
    user = "/user",
}

export const anchorPrefixComment = "ticket-comment-";
export const anchorPrefixSolution = "ticket-solution-";
export const anchorPrefixSolutionComment = "ticket-solution-comment-";
